// src/components/card/RadialCard.tsx
import { Star } from "lucide-react";
import { motion } from "motion/react";
import { useState, useEffect } from "react";

export default function RadialCard({
  data,
  index,
  activeIndex,
  radius,
  angleStep,
  rotationOffset,
  onClick,
  cardWidth,
}: any) {
  const isActive = index === activeIndex;

  // ✅ Combine scroll rotation into angle itself
  const cardAngle = index * angleStep + rotationOffset;

  const visualAngle = 270 + cardAngle;
  const angleRadians = visualAngle * (Math.PI / 180);

  const BASE_HEIGHT = 380;
  const ACTIVE_CARD_HEIGHT = 440;

  const x = radius * Math.cos(angleRadians);
  const y = radius * Math.sin(angleRadians) - (isActive ? 30 : 0);

  // --- Dynamic marginTop based on screen width ---
  const [marginTop, setMarginTop] = useState(30);

  useEffect(() => {
    const handleResize = () => {
      setMarginTop(window.innerWidth <= 768 ? 0 : 150);
    };
    handleResize(); // initialize
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <motion.div
      onClick={onClick}
      className="absolute cursor-pointer pointer-events-auto"
      style={{ width: cardWidth, marginTop }}
      animate={{
        x,
        y,
        rotate: cardAngle,
        height: isActive ? ACTIVE_CARD_HEIGHT : BASE_HEIGHT,
        zIndex: isActive ? 100 : 50 - Math.abs(index - activeIndex),
      }}
      transition={{ type: "spring", stiffness: 110, damping: 20 }}
    >
      <div
        className="w-full h-full rounded-[45px] overflow-hidden relative shadow-[0_20px_50px_rgba(0,0,0,0.5)] border border-white/10"
        style={{ backgroundColor: data.themeColor || "#151517" }}
      >
        <img
          src={data.image}
          className="absolute inset-0 w-full h-full object-cover"
          alt=""
        />

        <div className="absolute top-0 inset-x-0 p-7 flex justify-between items-start z-20">
          <div className="space-y-0.5 text-left text-white">
            <h4 className="text-xl font-black leading-none italic uppercase drop-shadow-lg">
              {data.name}
            </h4>
            <p className="text-[9px] font-black uppercase tracking-widest opacity-60">
              Series
            </p>
          </div>

          <div className="bg-black/60 backdrop-blur-md px-3 py-1 rounded-full flex items-center gap-1.5 border border-white/10">
            <Star size={10} fill="#fbbf24" className="text-yellow-400" />
            <span className="text-[11px] font-black tracking-tighter">4.7</span>
          </div>
        </div>
      </div>
    </motion.div>
  );
}
